/**
 * 下拉菜单、右键菜单与单选弹层共用的外观：条目 32 高、图标 14 平时灰色；危险项一直红色，
 * 由调用方排在最后并在前面加分隔线；单选的选中项右侧对勾加浅底。
 */
export const MENU_SURFACE_CLASS =
  'overflow-y-auto overflow-x-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-md'

// 条目里放了单选对勾（见 MENU_CHOICE_INLINE_CHECK_CLASS）就加浅底，与单选项选中时一样。
export const MENU_ITEM_CLASS =
  "relative flex min-h-8 has-[[data-menu-choice-check]]:bg-accent w-full min-w-0 cursor-default select-none items-center gap-2 rounded-sm px-2.5 py-1.5 text-left text-xs outline-none transition-colors focus:bg-accent/50 focus:text-foreground data-[highlighted]:bg-accent/50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5 [&_svg:not([class*='text-'])]:text-muted-foreground"

export const MENU_ITEM_DESTRUCTIVE_CLASS =
  "text-destructive focus:bg-destructive/10 focus:text-destructive data-[highlighted]:bg-destructive/10 [&_svg:not([class*='text-'])]:text-destructive [&_[data-menu-shortcut]]:text-current [&_[data-menu-shortcut]]:opacity-70"

/** 单选项：右侧留出对勾位置，选中加浅底。 */
export const MENU_CHOICE_ITEM_CLASS = 'pr-8 data-[state=checked]:bg-accent aria-selected:bg-accent'

export const MENU_CHOICE_CHECK_CLASS =
  'pointer-events-none absolute right-2.5 flex size-3.5 items-center justify-center text-foreground'

/**
 * 本身又是子菜单入口的单选项（如先选来源再选档位）：对勾跟在文字后、排在子菜单箭头前；
 * 对勾元素要带 data-menu-choice-check，条目才会加选中浅底。
 */
export const MENU_CHOICE_INLINE_CHECK_CLASS = 'ml-auto shrink-0 text-foreground'

export const MENU_SEPARATOR_CLASS = '-mx-1 my-1 h-px bg-border'

export const MENU_SHORTCUT_CLASS = 'ml-auto shrink-0 pl-4 text-[11px] text-muted-foreground'
